var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPormptmanagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 40,
    height: 40,
    transform: "translate(222 207)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M0,0H21.984V21.984H0Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-222 -207)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(231.008 216.008)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M.916,17a.916.916,0,0,1,.916.916v.916A2.759,2.759,0,0,0,4.58,21.58H17.4a2.759,2.759,0,0,0,2.748-2.748v-.916a.916.916,0,0,1,1.832,0v.916a4.591,4.591,0,0,1-4.58,4.58H4.58A4.591,4.591,0,0,1,0,18.832v-.916A.916.916,0,0,1,.916,17Z",
    transform: "translate(0 -1.428)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M0,4.58A4.591,4.591,0,0,1,4.58,0H17.4a4.591,4.591,0,0,1,4.58,4.58V5.5a.916.916,0,0,1-1.832,0V4.58A2.759,2.759,0,0,0,17.4,1.832H4.58A2.759,2.759,0,0,0,1.832,4.58V5.5A.916.916,0,0,1,0,5.5Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M6.211,7.344a.916.916,0,0,1-.143,1.288L2.382,11.58l3.686,2.949a.916.916,0,0,1-1.144,1.431L.344,12.3a.916.916,0,0,1,0-1.431L4.924,7.2a.916.916,0,0,1,1.288.143Z",
    transform: "translate(0 -0.588)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M17.2,7.344A.916.916,0,0,1,18.488,7.2l4.58,3.664a.916.916,0,0,1,0,1.431l-4.58,3.664a.916.916,0,1,1-1.144-1.431L21.03,11.58,17.344,8.631A.916.916,0,0,1,17.2,7.344Z",
    transform: "translate(-1.428 -0.588)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M13.832,4.035a.916.916,0,0,1,.629,1.132L10.8,17.992a.916.916,0,0,1-1.761-.5L12.7,4.664A.916.916,0,0,1,13.832,4.035Z",
    transform: "translate(-0.756 -0.336)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPormptmanagement);
export default __webpack_public_path__ + "static/media/pormptmanagement.2666e9fa49b4aedf064a1c7d4520a5ce.svg";
export { ForwardRef as ReactComponent };